var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full",attrs:{"id":"app"}},[(_vm.mainLoading)?_c('Loader',{attrs:{"loading":_vm.mainLoading,"fullscreen":"","target":"body","lock":""}}):(_vm.isLoggedIn)?_c('Admin'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }